import DividerMui from '@mui/material/Divider';

import { COLORS } from '~/styles/colors';

// Define the prop types
interface DividerProps {
  mb?: number; // margin-bottom, default value of 2
  mt?: number; // margin-top, default value of 2
  width?: string | number; // width can be a string or number
}

export const Divider = ({ mb = 2, mt = 2, width }: DividerProps) => {
  return <DividerMui sx={{ mt: `${mt}px`, mb: `${mb}px`, width, borderColor: COLORS.grey200 }} />;
};
